import { registerLocaleData } from "@angular/common";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import ptBr from "@angular/common/locales/pt";
import { EnvironmentProviders, ErrorHandler, LOCALE_ID, NgModule, Provider } from "@angular/core";
import { MatDialogModule } from "@angular/material/dialog";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from "@angular/router";
import Bugsnag from "@bugsnag/js";
import { BugsnagErrorHandler } from "@bugsnag/plugin-angular";

import { ErrorInterceptor } from "@core/interceptors/error/error-interceptor/error.interceptor";
import { NavbarComponent } from "@layouts/navbar/navbar.component";
import { SpacerComponent } from "@shared/components/spacer/spacer.component";
import { StepsComponent } from "@shared/components/steps/steps.component";
import { ToastComponent } from "@shared/components/toast/toast.component";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

import { environment } from "../environments/environment";

registerLocaleData(ptBr);

const providers: Array<Provider | EnvironmentProviders> = [
  provideHttpClient(withInterceptorsFromDi()),
  { provide: LOCALE_ID, useValue: "pt" },
  { provide: "Window", useValue: window },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ErrorInterceptor,
    multi: true,
  },
];

export function errorHandlerFactory(): BugsnagErrorHandler {
  return new BugsnagErrorHandler();
}

if (environment.BUGSNAG_KEY) {
  Bugsnag.start({
    apiKey: environment.BUGSNAG_KEY,
    appVersion: environment.version,
    redactedKeys: ["cpf", "phone"],
  });

  providers.push({ provide: ErrorHandler, useFactory: errorHandlerFactory });
}

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatDialogModule,
    MatSnackBarModule,
    AppRoutingModule,
    NavbarComponent,
    StepsComponent,
    SpacerComponent,
    RouterModule.forRoot([], { scrollPositionRestoration: "enabled" }),
    ToastComponent,
  ],
  providers,
})
export class AppModule {}
